import { pointsToBox } from "@logic/lib/2d"

import type { TransactionOperation } from ".."
import { getMousePositionOnScreen } from ".."
import { startPointState } from "../../../inputs"

export const getDragBox: TransactionOperation<
  undefined,
  ReturnType<typeof pointsToBox> | null
> = (transactors) => {
  const { get } = transactors
  const mouse = getMousePositionOnScreen(transactors)
  const startPoint = get(startPointState)
  if (startPoint) {
    return pointsToBox(startPoint, mouse)
  }

  return null
}
